import { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import {
  addDays,
  getMonth,
  isSameDay,
  eachDayOfInterval,
  intervalToDuration
} from 'date-fns';

import dayjs from 'dayjs'

import {
  getStockByDates,
  mergeStocksByDates,
  getDurationOptions,
  adjustStockForDuration,
} from './availability'
import { months } from './months';

import "react-datepicker/dist/react-datepicker.css";
import './Calendar.css'
import { DEFAULT_BUFFER_DAYS } from './constants';

const Calendar = (props) => {
  const {
    show,
    cartData,
    productData,
    dateRange,
    onChangeDate,
    rentalDuration,
    calendarRef,
    productSku: currentSku,
    isActiveDayDelivery
  } = props;

  const [ stockByDate, setStockByDate ] = useState({})
  const [ fistDay, setFirstDay ] = useState(null)
  const [ bufferDays, setBufferDays] = useState(null)

  const isProductModal = show === 'product';

  // console.log('calendar @dateRange', {dateRange})

  const daysFromInterval = eachDayOfInterval({
    start: dateRange[0], end:dateRange[1]
  })

  useEffect(() => {
    if(isProductModal && productData && currentSku) {  // modal from product
      const relevantAvs = productData.skuAvs.filter(item => currentSku.strId === item.skuStrId);
      const disabledDates = getStockByDates(relevantAvs)
      const safeDays = currentSku.daysBeforeRent;
      setBufferDays(safeDays)

      adjustStockForDuration(disabledDates, rentalDuration, isActiveDayDelivery, safeDays)
      setStockByDate(disabledDates)

    } else if (!isProductModal && cartData && cartData.skus.length) {
      const { skus } = cartData;

      let commonStockByDates = {}
      for (const sku of skus) {
        const relevantAvs = productData.skuAvs.filter(item => sku.strId === item.skuStrId);
        const stockByDatesForSKU = getStockByDates(relevantAvs)
        mergeStocksByDates(commonStockByDates, stockByDatesForSKU)
      }

      // take the highest daysBeforeRent value
      const safeDaysArray = skus.map(item => Number(item.daysBeforeRent) || DEFAULT_BUFFER_DAYS).sort();
      const safeDays = safeDaysArray[0];
      setBufferDays(safeDays)
      adjustStockForDuration(commonStockByDates, rentalDuration, isActiveDayDelivery, safeDays)
      setStockByDate(commonStockByDates)
    }

  }, [rentalDuration, currentSku])


  const getDayClassName = (day) => {
    const dayStr = dayjs(day).format('YYYY-MM-DD')

    const isDayInDateRange = daysFromInterval.some(date => isSameDay(new Date(date), day))
    const isNow = isSameDay(new Date(), day)

    let classes = ''
    if(isNow) {
      classes += 'rntr-current-day'
    }

    if(isDayInDateRange) {
      classes += ' rntr-day-in-range'
    }

    if (stockByDate[dayStr] <= 0) {
      classes += ' rntr-disabled-date'
    }

    return classes
  }

  useEffect( () => {
    if (isActiveDayDelivery) {
      setFirstDay(new Date())
    } else {
      let date = new Date()
      const safeDays = bufferDays ? bufferDays : DEFAULT_BUFFER_DAYS;
      date.setDate(date.getDate() + safeDays)
      setFirstDay(date)
    }
  },[isActiveDayDelivery, bufferDays])

  const handleSetEndDate = (value) => {
    const dateFrom = value;
    const dateTo = addDays(value, rentalDuration - 1);
    onChangeDate({dateFrom, dateTo})
  }

  const renderHeader = (props) => {
    const {
      date,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled,
    } = props;

    return (
      (
        <div className='rntr-react-datepicker__current-month' >
          <button
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            className='rntr-react-datepicker__prev-button rntr-react-datepicker__control-button'>
            <span className='rntr-react-datepicker__arrow'/>
          </button>
          { months[getMonth(date)] }

          <button
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            className='rntr-react-datepicker__next-button rntr-react-datepicker__control-button'>
            <span className='rntr-react-datepicker__arrow'/>
          </button>
        </div>
      )
    )
  }

  return (
    <div ref={ calendarRef }>
      <DatePicker
        inline
        selectsRange
        selected={ dateRange[0] }
        startDate={ dateRange[0] }
        endDate={ dateRange[1] }
        classPrefix='rntr-date-range'
        onSelect={ handleSetEndDate }
        className='rntr-date-picker-input'
        calendarClassName='rntr-calendar'
        disabledKeyboardNavigation
        dateFormat="dd.MM.yyyy"
        minDate={ fistDay }
        dayClassName={ getDayClassName  }
        renderCustomHeader={renderHeader}
      />
    </div>
  );
}

export default Calendar;
